import { Erc20__factory } from '@/contracts';
import { CONSTANT } from '@/store/constants';

import { sharedProvider } from '@/store/provider';
import { useAddress } from '@/store/selector';
import useSWR from 'swr';

async function fetchBalance(address: string) {
    if (!address) {
        throw new Error('Invalid Address');
    }
    const provider = sharedProvider.get(CONSTANT.RPC_WLD);
    const contract = Erc20__factory.connect(CONSTANT.TOKEN_WLD, provider);

    const balance = await contract.balanceOf(address);

    return balance;
}

export function useBalance() {
    const address = useAddress();
    const data = useSWR(
        [address, 'fetch-balance'],
        () => fetchBalance(address),
        {
            dedupingInterval: 20000,
            shouldRetryOnError: false,
        }
    );

    return { ...data, address };
}
